import React, {Component} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import {connect} from "react-redux";

class BPContestPhaseRow extends Component{
    constructor(props) {
        super(props);
        this.onLoading = this.props.onLoading.bind(this);
        this.onLoadMessage = this.props.onLoadMessage.bind(this);
        this.onloadPhases = this.props.onLoadPhases.bind(this);
    }
    componentDidMount() {
    }
    render() {
        const {index,item, contestId} = this.props;
        const buttonStyle = {
            width: '200px'
        }
        return(
            <tr>
                <td>{index+1}</td>
                <td>
                    {this.props.isRoleFWDContest && <Link to={'/bp/contest/phase/'+item?.id+'/edit'}>{item?.name}</Link>}
                    {!this.props.isRoleFWDContest && <span>{item?.name}</span>}
                </td>
                <td><span>{item?.description}</span></td>
                <td><span>{item?.createdDate}</span></td>
                <td style={buttonStyle}>
                    <Link to={'/bp/contest/phase/'+item.id+'/detail'} className={'btn btn-info btn-sm d-inline'}>Xem chi tiết</Link>
                    {this.props.isRoleFWDContest && <button type='button' onClick={() => {
                        this.onLoading(true);
                        axios.post('/api/bankportal/contest/phase/' + item?.id + '/inactive')
                            .then((response) => {
                                if (response.data != null) {
                                    this.onLoadMessage('Xóa đợt thành công');
                                    this.onLoading(false);
                                    this.onloadPhases(contestId);
                                } else {
                                    this.onLoadMessage('Xảy ra lỗi khi thực hiện xóa');
                                    this.onLoading(false);
                                }
                            })
                            .catch(error => {
                                console.error('There was an error!', error);
                                this.onLoadMessage(error.message);
                                this.onLoading(false);
                            })
                    }} className="btn btn-danger btn-sm ml-2 d-inline">Xóa</button>
                    }
                </td>
            </tr>
        )
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO };
};

export default connect(mapStateToProps)(BPContestPhaseRow)